export function formatChatError(error: any, fallback: string): string {
    const raw = String(error?.details?.error || error?.message || "");
    const status = Number(error?.response?.status || error?.status || error?.details?.status);

    // Upstream debug pages may contain SQL, paths and huge stack traces.
    if (status >= 500) return `${fallback}. Попробуйте позже.`;
    if (status === 401 || status === 403) return "Нет доступа к этому чату";
    if (status === 404) return "Чат не найден или у вас нет доступа";
    if (status === 429) return "Слишком много запросов. Попробуйте через полминуты.";
    if (/timeout|exceeded|ECONNABORTED/i.test(raw)) return "Не удалось обновить чаты: сервер долго не отвечает";
    if (/network/i.test(raw)) return "Нет соединения. Проверьте интернет";
    if (/not_found|forbidden/i.test(raw)) return "Чат не найден или у вас нет доступа";

    return fallback;
}
